// Общие стили мастера местоположения: профиль, первый вход и телефон

export const PRIMARY = '#1570ef';
export const BORDER = '#e2e8f0';
export const TEXT = '#1e293b';
export const MUTED = '#64748b';

export const buttonSx = { height: 40, textTransform: 'none', fontWeight: 600, borderRadius: '8px', whiteSpace: 'nowrap' } as const;
export const primaryButtonSx = { ...buttonSx, bgcolor: PRIMARY, boxShadow: 'none', '&:hover': { bgcolor: '#1d4ed8', boxShadow: 'none' } };
export const outlinedButtonSx = { ...buttonSx, borderColor: '#cbd5e1', color: '#334155', bgcolor: '#fff', '&:hover': { borderColor: '#94a3b8', bgcolor: '#f8fafc' } };

export const cardSx = { p: 2, borderRadius: '12px', border: `1px solid ${BORDER}`, bgcolor: '#fff' };
export const softCardSx = { p: 2, borderRadius: '12px', border: `1px solid ${BORDER}`, bgcolor: '#f8fafc' };

export const titleSx = { fontWeight: 700, color: TEXT, fontSize: '1rem' };
export const hintSx = { color: MUTED, fontSize: '0.85rem', lineHeight: 1.5 };
export const monoSx = { fontFamily: 'monospace', fontWeight: 600, color: TEXT, fontSize: '0.84rem' };

export const alertSx = { borderRadius: '8px', fontSize: '0.85rem', alignItems: 'flex-start' };

/** Номер шага в инструкции */
export const stepNumberSx = {
  width: 24, height: 24, borderRadius: '50%', flexShrink: 0, bgcolor: 'rgba(21,112,239,0.1)', color: PRIMARY,
  fontWeight: 700, fontSize: 12.5, display: 'flex', alignItems: 'center', justifyContent: 'center'
};

export const iconBoxSx = {
  width: 40, height: 40, borderRadius: '12px', flexShrink: 0, bgcolor: 'rgba(21,112,239,0.1)', color: PRIMARY,
  display: 'flex', alignItems: 'center', justifyContent: 'center'
};
